import { useNavigate, useLocation } from 'react-router-dom';

import { canonicalLang } from '@shared/config';

/**
 * Navigate to the same funnel step under a different locale, swapping the `:lang`
 * segment in place.
 *
 * Shared by the language switcher and the market switcher so the rule lives once —
 * mirroring `useSwitchLocale` on the marketing side. It tests the leading segment
 * with `canonicalLang`, not membership of the selectable list: a retired alias
 * prefix (`/nl-BE/plan`) is a real locale segment and must be REPLACED. Treating
 * it as "no prefix" produced `/nl/nl-BE/plan`.
 *
 * `replace: true` keeps switching language out of the back-button history, so Back
 * still means "the previous step" rather than "the same step in the old language".
 */
export function useSwitchFunnelLocale(): (code: string) => void {
  const navigate = useNavigate();
  const location = useLocation();

  return (code: string): void => {
    const segments = location.pathname.split('/').filter(Boolean);
    if (segments.length && canonicalLang(segments[0])) segments[0] = code;
    else segments.unshift(code);
    navigate(`/${segments.join('/')}${location.search}`, { replace: true });
  };
}
